var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVisibleOn = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#A1A3A5",
  d: "M20 7.5C11.667 7.5 4.55 12.683 1.667 20c2.883 7.317 10 12.5 18.333 12.5 8.334 0 15.45-5.183 18.334-12.5C35.45 12.683 28.334 7.5 20 7.5zm0 20.833c-4.6 0-8.333-3.733-8.333-8.333S15.4 11.667 20 11.667 28.334 15.4 28.334 20 24.6 28.333 20 28.333zM20 15c-2.766 0-5 2.233-5 5s2.234 5 5 5c2.767 0 5-2.233 5-5s-2.233-5-5-5z"
})));
export default SvgVisibleOn;